import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'wouter';

// import useEvents from '../../hooks/useEvents';
import useFilms from '../../hooks/useFilms';

import Blocks from '../blocks/Blocks';
import MultiProjectron from '../icons/MultiProjectron';
import Carousel from '../partials/Carousel';
import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/home.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function HomePage({ page }) {
    const { featuredEvents = null, blocks = null } = page || {};
    const { data: films = featuredEvents } = useFilms({ query: { shuffle: true, count: 9 } });

    const [image, setImage] = useState(null);
    const [url, setUrl] = useState(null);
    const [open, setOpen] = useState(true);

    const onChange = useCallback(
        (item) => {
            const { image: itemImage = null, url: itemUrl = null } = item || {};
            setImage(itemImage);
            setUrl(itemUrl);
        },
        [setImage, setUrl],
    );

    const willChange = useCallback(() => {
        setOpen(!open);
    }, [open, setOpen]);

    const onRest = useCallback(
        (opn) => {
            if (!opn) {
                setOpen(true);
            }
        },
        [setOpen],
    );

    // Initial
    useEffect(() => {
        const [firstEvent = null] = films || [];
        const { image: itemImage = null, url: itemUrl } = firstEvent || {};
        setImage(itemImage);
        setUrl(itemUrl);
    }, [setImage, setUrl, films]);

    const hasFilms = films !== null && films.length > 0;

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Carousel
                className={styles.carousel}
                active={hasFilms}
                items={films}
                itemType="film_basic"
                index={0}
                onChange={onChange}
                willChange={willChange}
            />
            {url !== null ? (
                <Link to={url}>
                    <MultiProjectron
                        className={styles.projectron}
                        image={image}
                        open={open}
                        onRest={onRest}
                    />
                </Link>
            ) : null}
            <Blocks blocks={blocks} />
        </div>
    );
}

HomePage.propTypes = propTypes;

export default HomePage;
